import { render, staticRenderFns } from "./SmsModal.vue?vue&type=template&id=0904fdb3&"
import script from "./SmsModal.vue?vue&type=script&lang=js&"
export * from "./SmsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports